export default __webpack_public_path__ + "static/media/tag_low.9197bb69.png";